import type { InsightsReportResource, NewInsightsReportResource } from "app/client/resources/insightsReportResource";
import type { InsightsGranularity, InsightsTimeRange } from "~/areas/insights/insightsCadence";
import type { InsightsLicenseCheckResource } from "~/client/resources/insightsLicenseCheckResource";
import type { Client } from "../client";
import type { GetInsightsForReportBffResponse } from "../resources/insightsReportBffResponse";
import BasicRepository from "./basicRepository";

export enum InsightsMetricsSplit {
    None = "None",
    Project = "Project",
    ProjectGroup = "ProjectGroup",
    Environment = "Environment",
    EnvironmentGroup = "EnvironmentGroup",
    Tenant = "Tenant",
    TenantTagSet = "TenantTagSet",
}

class InsightsReportRepository extends BasicRepository<InsightsReportResource, NewInsightsReportResource> {
    constructor(client: Client) {
        super("InsightsReports", client);
    }

    getInsightsLicenseCheck(): Promise<InsightsLicenseCheckResource> {
        return this.client.get("~/bff/insights/reports/license-check");
    }

    async bff(report: InsightsReportResource, split: InsightsMetricsSplit, timeRange: InsightsTimeRange, granularity: InsightsGranularity, tenantTagSetId?: string): Promise<GetInsightsForReportBffResponse> {
        return await this.client.get<GetInsightsForReportBffResponse>("~/bff/spaces/{spaceId}/insights/reports/{reportId}{?split,granularity,timeRange,tenantTagSetId}", {
            spaceId: report.SpaceId,
            reportId: report.Id,
            split,
            tenantTagSetId,
            timeRange,
            granularity,
        });
    }

    async requestTrial() {
        return await this.client.post("~/bff/insights/request-insights-trial");
    }
}

export default InsightsReportRepository;
